<fpc-input-field-label 
[label]="_label" 
[required]="required" 
[popoverText]="_popoverText" 
[labelColor]="labelColor" 
[iconSize]="iconSize">
  <input 
  [id]="id" type="text" class="form-control mb-0" [ngClass]="(inputSize == 'sm' ? 'form-control-sm': '') + ' ' + inputClass" [formControl]="control"
    [placeholder]="placeholder" [name]="control" [required]="required" [minlength]="minlength" [maxlength]="maxlength" />
</fpc-input-field-label>